export default "skymp5-front/1bd974179b8f1abac19b3aac34e8044e.gif";